import { defineComponent as _defineComponent } from 'vue'
import useGridConfiguration from '@/composables/useGridConfiguration'
import store from '@/store/store'
import { ModuleNamespaces } from '@/store/types/storeGlobalTypes'
import { computed, onBeforeMount } from 'vue'
import useContactInvoices from './composables/useContactInvoices'
import Grid from '@/components/grids/LfGrid/LfGridComponent.vue'
import {
  CommandClickEventArgs,
  CommandColumnModel,
  ContextMenuClickEventArgs,
  RecordClickEventArgs
} from '@syncfusion/ej2-vue-grids'
import { ListNames } from '@/store/modules/configuration/configurationTypes'
import { Icons } from '@/icons/icons'
import { ActionName } from '@/components/grids/LfGrid/LfGridTypes'
import { useI18n } from 'vue-i18n-composable'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContactInvoicesComponent',
  props: {
  listName: {
    type: String,
    required: true,
    default: 'default'
  },
  context: {
    type: String,
    default: 'contactInvoices'
  }
},
  setup(__props) {

const props = __props;

const { t } = useI18n()

// DEFINE PROPS  ======================================================================================================


const commandsBts: CommandColumnModel[] = [
  {
    title: 'Abrir nueva pestaña',
    type: 'None',
    buttonOption: {
      iconCss: Icons.OPEN_WINDOW,
      cssClass: 'custombutton'
    }
  }
]
const contextMenuItems = [
  {
    id: ActionName.EDIT,
    text: t('action_buttons.edit').toString(),
    iconCss: Icons.EDIT
  },
  {
    id: ActionName.OPEN_NEW_TAB,
    text: t('action_buttons.open_new_window').toString(),
    iconCss: Icons.OPEN_WINDOW
  }
]
// COMPOSABLES   ======================================================================================================
const { gridConfiguration } = useGridConfiguration({
  listName: props.listName,
  context: props.context,
  commandButtons: commandsBts
})

const { invoices, read, open } = useContactInvoices({
  listName: ListNames.LIST_CUSTOMER_INVOICES
})

// STORE GETTERS ======================================================================================================
const selectedEntityName = computed(() => store.getters[`${ModuleNamespaces.ENTITIES}/getSelectedEntityName`])

const selectedRegisterId = computed(() =>
  store.getters[`${ModuleNamespaces.SELECTED_REGISTER}/getSelectedRegisterId`](selectedEntityName.value).toString()
)
// EVENTS =============================================================================================================
const onRowClick = (args: RecordClickEventArgs) => {
  const { rowData } = args
  const { idEntity, idInvoice } = rowData as any
  open(idEntity, idInvoice)
}

const onCommandClick = (args: CommandClickEventArgs) => {
  const { rowData } = args
  const { idEntity, idInvoice } = rowData as any
  open(idEntity, idInvoice, '_blank')
}

const onContextMenuClicked = ({ rowInfo, item }: ContextMenuClickEventArgs) => {
  const { rowData } = rowInfo as any
  const { idEntity, idInvoice } = rowData as any
  const { id } = item
  if (id === ActionName.EDIT) {
    open(idEntity, idInvoice)
  }
  if (id === ActionName.OPEN_NEW_TAB) {
    open(idEntity, idInvoice, '_blank')
  }
}
// HOOKS =============================================================================================================
onBeforeMount(async () => {
  await read(selectedRegisterId.value)
})

return { __sfc: true,t, props, commandsBts, contextMenuItems, gridConfiguration, invoices, read, open, selectedEntityName, selectedRegisterId, onRowClick, onCommandClick, onContextMenuClicked, Grid }
}

})